import { render, staticRenderFns } from "./TextMaterials.vue?vue&type=template&id=a8edf96e&scoped=true"
import script from "./TextMaterials.vue?vue&type=script&lang=js"
export * from "./TextMaterials.vue?vue&type=script&lang=js"
import style0 from "./TextMaterials.vue?vue&type=style&index=0&id=a8edf96e&prod&lang=scss&scoped=true"
import style1 from "./TextMaterials.vue?vue&type=style&index=1&id=a8edf96e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8edf96e",
  null
  
)

export default component.exports